export const DEFAULT_COLUMNS_TOKENS = {
  base: 1.2,
  sm: 2,
  md: 3,
  lg: 4,
  '2xl': 5,
};

export const DEFAULT_SPACE_TOKENS = { base: 2 };
